import { render, staticRenderFns } from "./intervencionesShow.vue?vue&type=template&id=be4c5b80"
import script from "./intervencionesShow.vue?vue&type=script&lang=js"
export * from "./intervencionesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports